module.exports = __webpack_public_path__ + "d97d4d253f599df19bd143bcb97609f1.svg";